$(function () {
    var $root = $('.application-form .main.conditional-fields');
    if (!$root.length) $root = $('.application-form');

    var uid = 0;

    $root.find('.form-group-container.conditional-field').each(function () {
        var $box = $(this);
        if ($box.data('acc-inited')) return;
        if ($box.closest('.acc-leaf-wrap').length) return;

        var $row      = $box.find('> .row').first();
        var $wrapper  = $row.find('> .form-group-wrapper').first();
        var $children = $wrapper.children('.form-group-container.conditional-field');

        var parentTitle =
            $.trim(
                $row.find('> .d-flex.flex-row.px-0 h5').first().text() ||
                $row.find('> .d-flex.flex-row.px-0').first().text()
            );

        var $targets, isLeaf = false;

        if ($children.length) {
            $box.addClass('acc-has-children');
            $targets = $children;
        } else {
            $box.addClass('acc-leaf');
            var $leafWrap = $box.children('.acc-leaf-wrap');
            if (!$leafWrap.length) {
                $box.wrapInner('<div class="acc-leaf-wrap"></div>');
                $leafWrap = $box.children('.acc-leaf-wrap');
            }
            $box.data('acc-inited', 1);
            $targets = $leafWrap;
            isLeaf = true;
        }

        $targets.each(function () {
            var $pane = $(this);
            if ($pane.data('acc-inited')) return;

            var $row2    = $pane.find('> .row').first();
            var $header  = $row2.find('> .d-flex.flex-row.px-0').first();
            var $body    = $row2.find('> .form-group-wrapper').first();

            if (isLeaf && !$header.length) {
                $header = $('<div class="d-flex flex-row px-0 acc-head"/>')
                    .append($('<h5/>').text(parentTitle || 'Skiltis'))
                    .prependTo($row2);
            }

            if (!$body.length) {
                var $rest = $row2.children().not($header);
                $body = $('<div class="form-group-wrapper"></div>').appendTo($row2);
                $rest.appendTo($body);
            }

            if (!$header.length || !$body.length) return;

            var id = $body.attr('id') || ('acc_inner_' + (uid++));
            $body.attr('id', id).addClass('collapse show acc-body');

            let headerAtt = {
                tabindex: 0,
                'aria-expanded': 'true'
            }

            if(!isLeaf){
                headerAtt.role = 'button';
                headerAtt['data-bs-toggle'] = 'collapse';
                headerAtt['data-bs-target'] = '#' + id;
                headerAtt['aria-controls'] = id;
            }

            $header.addClass('acc-head').attr(headerAtt);

            $pane.data('acc-inited', 1);
        });
    });

    $(document).on('keydown', '.acc-head', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).click(); }
    });

    $(document).on('shown.bs.collapse hidden.bs.collapse', '.acc-body', function () {
        var open = $(this).hasClass('show');
        $('[data-bs-target="#' + this.id + '"]').attr('aria-expanded', open);
    });
});

$(document).on('click', '.js-acc-toggle-all', function () {
    var $btn = $(this);
    var $all = $('.acc-body.collapse');

    var shouldExpand = $all.filter(':not(.show)').length > 0;

    $all.each(function () {
        var instance = bootstrap.Collapse.getOrCreateInstance(this, { toggle: false });
        if (shouldExpand) {
            instance.show();
            $('[data-bs-target="#' + this.id + '"]').attr('aria-expanded', 'true');
        } else {
            instance.hide();
            $('[data-bs-target="#' + this.id + '"]').attr('aria-expanded', 'false');
        }
    });

    $btn.text(shouldExpand ? $btn.data('label-collapse') : $btn.data('label-expand'));
});

$(function () {
    var $btn = $('.js-acc-toggle-all');
    if (!$btn.length) return;
    var anyCollapsed = $('.acc-body.collapse:not(.show)').length > 0;
    $btn.text(anyCollapsed ? $btn.data('label-expand') : $btn.data('label-collapse'));
});
